/** An IBAN written in groups of four characters, as it is read aloud and printed. */
export function formatIban(iban: string): string {
  return iban.replace(/(.{4})/g, "$1 ").trim();
}
